import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { FilterProvider } from "./state/FilterContext";
import "./App.css";

import TopBar from "./components/TopBar"; // keep if you already use it

import FixturesScraper from "./pages/FixturesScraper";

export default function App() {
  return (
    <BrowserRouter>
      <FilterProvider>
        <div className="app">
          {/* Optional (your existing header with crest etc.) */}
          <TopBar />

          <main className="main" id="main">
            <Routes>
              {/* Make Results the home for now */}
              <Route path="/" element={<Navigate to="/fixtures-scraper" replace />} />

              <Route path="/fixtures-scraper" element={<FixturesScraper />} />

              <Route path="*" element={<Navigate to="/fixtures-scraper" replace />} />
            </Routes>
          </main>
        </div>
      </FilterProvider>
    </BrowserRouter>
  );
}
